import React from 'react';
import CardPreview from '../components/CardPreview';
import PanelNotifications from '../components/PanelNotifications';
import { PrimaryFieldInputs } from '../components/FieldInputs';
import { EditableAdditionalFields } from '../components/AdditionalFields';

export default function ScannerDetailsPanel({
  imageSrc,
  primaryFields,
  primaryFieldValues,
  onPrimaryFieldChange,
  additionalFields,
  onAdditionalFieldLabelChange,
  onAdditionalFieldChange,
  onAddAdditionalField,
  onRemoveAdditionalField,
  onConfirm,
  onCancel,
  isScanning,
  scanError,
  onRetryScan,
  onDismissScanError,
  hasExtractedData
}) {
  return (
    <div className="space-y-8">
      <PanelNotifications
        isScanning={isScanning}
        scanError={scanError}
        hasExtractedData={hasExtractedData}
        onRetryScan={onRetryScan}
        onDismissScanError={onDismissScanError}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        <CardPreview imageSrc={imageSrc} />
        <div className="space-y-4">
          <PrimaryFieldInputs
            fields={primaryFields}
            values={primaryFieldValues}
            onFieldChange={onPrimaryFieldChange}
          />
          <EditableAdditionalFields
            additionalFields={additionalFields}
            onLabelChange={onAdditionalFieldLabelChange}
            onValueChange={onAdditionalFieldChange}
            onAddField={onAddAdditionalField}
            onRemoveField={onRemoveAdditionalField}
          />
        </div>
      </div>

      <div className="flex items-center justify-between pt-6 border-t border-white/10">
        <button
          type="button"
          onClick={onCancel}
          className="px-6 py-3 rounded-2xl font-semibold text-white bg-white/10 hover:bg-white/20 transition-colors border border-white/15"
          disabled={isScanning}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="px-6 py-3 rounded-2xl font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 shadow-lg"
          disabled={isScanning}
        >
          {isScanning ? 'Processing...' : 'Confirm'}
        </button>
      </div>
    </div>
  );
}

